import { Record } from 'immutable';

import { SemanticRuleListEntity } from '../components/semantic-rule-list/semantic-rule-list.entity';

export interface ISemanticRuleState {
	loading: boolean;
	semanticRuleList: SemanticRuleListEntity;
}

export const defaults: ISemanticRuleState = {
	loading: false,
	semanticRuleList: SemanticRuleListEntity.build([]),
};

export const SemanticRuleFeatureKey = 'semantic-rule';

export class SemanticRuleState extends Record<ISemanticRuleState>(defaults) {
	public static key = SemanticRuleFeatureKey;

	public setLoading(isLoading: boolean): SemanticRuleState {
		return this.set('loading', isLoading);
	}

	public setRankingList(
		semanticRuleList: SemanticRuleListEntity
	): SemanticRuleState {
		return this.set('semanticRuleList', semanticRuleList);
	}
}
